const RULES_PLACEHOLDER =
  "Eligibility and age cut-offs follow the official Bulandi 2026 circular.\n\nDetailed format, judging criteria, materials, and safety guidelines will be published by the coordinators before the event.";
function rulesBody(summary) {
  return `${summary}\n\n${RULES_PLACEHOLDER}`;
}
const RS_FOOT_LOOSE =
  "Express yourself through movement and rhythm. Put your best foot forward and bring your unique dance style to the stage.";
const RS_WANNA_B_PICASSO =
  "Unleash your creativity through art and imagination. Participants will create drawings based on a predesigned shape.";
const RS_VERSE_VIBES =
  "Present a Sanskrit shloka with clarity, rhythm, and understanding. Focus on pronunciation, expression, and delivering the meaning effectively.";
const RS_MIC_DROP =
  "Step onto the stage and express your voice with confidence. Deliver a powerful performance through a short, impactful rendition of your chosen song.";
const RS_TALE_SPIN =
  "Bring stories to life through expression and narration. Present a mythological story with a meaningful takeaway through your voice and performance.";
const RS_FUNK_FUSION =
  "Bring rhythm, coordination, and chemistry together as a duo. Put your best foot forward and deliver a performance that showcases sync, energy, and connection.";
const RS_MIND_MAZE =
  "Analyze real-world problems, structure your thinking, and present impactful solutions. Test your ability to think critically, act strategically, and communicate effectively.";
const RS_SHER_LOCK_KEY =
  "Step into a world of clues, secrets, and hidden connections.\n\nWork as a team to analyze evidence, decode patterns, and solve the mystery before time runs out.";
const RS_TOTE_STUDIO =
  "Design your own tote using creativity and personal style.\n\nTransform a plain tote into a unique expression through colours, patterns, and detailing.";
const RS_KNIVES_OUT =
  "Bring your culinary creativity to life by crafting innovative dishes. Showcase your skills through taste, presentation, and originality.";
const RS_RIDDLE_RUSH =
  "Complete a series of fun and engaging tasks that test speed, focus, and problem-solving skills. Move through each challenge quickly and accurately to finish in the shortest time.";
const RS_BRAIN_BURN =
  "Test your general knowledge and problem-solving skills by completing a crossword challenge. Solve accurately and quickly to secure your position.";
const RS_NITRO_RUSH =
  "Race against the clock and navigate the track with speed and control. Deliver the fastest timing to qualify and move ahead in the competition.";
const RS_PROFIT_OR_LAUGH =
  "Present a creative and humorous take on a startup idea.\n\nBlend imagination, storytelling, and persuasion to deliver a pitch that is both convincing and entertaining.";
const RS_INK_IT =
  "Showcase neatness, clarity, and consistency through Hindi handwriting. Focus on presentation and precision while writing the given content.";
const RS_TRADE_OFF_ARENA =
  "A high-energy family game show combining music, quizzes, fun challenges, and teamwork.\n\nFrom offstage participation to onstage showdown, families will compete through engaging and dynamic participations.";
const RS_VIRAL_VOLTAGE =
  "A high-energy digital content challenge where participants create engaging reels across different themes and participations. Over 3 weeks, participants must showcase creativity, storytelling, and audience engagement through short-form content created for social media.";
const PRIZES_TBA = "To be announced";
const L_J =
  "Juniors: 4 years to 8 years (born between 2 July 2017 and 1 July 2022, inclusive).";
const L_I =
  "Intermediates: 9 years to 15 years (born between 2 July 2010 and 1 July 2017, inclusive).";
const L_S = "Seniors: 16 years and above (born on or before 1 July 2010).";
const L_F = "Family event — team category as per circular.";
export const bulandiSubEvents = [
  {
    id: "foot-loose-juniors",
    catalogNo: 1,
    name: "Foot Loose",
    eventKind: "Solo Dance",
    ageTier: "juniors",
    ageGroup: "under15",
    ageGroupLabel: L_J,
    participationType: "Onstage",
    teamSize: "1",
    pageNo: "1",
    imageUrl: "/icon/juniors/foot_loose.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_FOOT_LOOSE,
    rules: rulesBody(RS_FOOT_LOOSE),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "wanna-b-picasso-juniors",
    catalogNo: 2,
    name: "Wanna-B-Picasso",
    eventKind: "Inspired Drawing",
    ageTier: "juniors",
    ageGroup: "under15",
    ageGroupLabel: L_J,
    participationType: "Offstage",
    teamSize: "1",
    pageNo: "1",
    imageUrl: "/icon/juniors/wanna_be_picasso.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_WANNA_B_PICASSO,
    rules: rulesBody(RS_WANNA_B_PICASSO),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "verse-vibes-juniors",
    catalogNo: 3,
    name: "Verse Vibes",
    eventKind: "Shloka Chanting",
    ageTier: "juniors",
    ageGroup: "under15",
    ageGroupLabel: L_J,
    participationType: "Onstage",
    teamSize: "1",
    pageNo: "1",
    imageUrl: "/icon/juniors/verse_vibes.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_VERSE_VIBES,
    rules: rulesBody(RS_VERSE_VIBES),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "riddle-rush-juniors",
    catalogNo: 4,
    name: "Riddle Rush",
    sheetHeaderName: "Riddle Rush",
    eventKind: "Puzzle Relay",
    ageTier: "juniors",
    ageGroup: "under15",
    ageGroupLabel: L_J,
    participationType: "Onstage",
    teamSize: "1",
    pageNo: "1",
    imageUrl: "/icon/juniors/riddle_rush.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_RIDDLE_RUSH,
    rules: rulesBody(RS_RIDDLE_RUSH),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "mic-drop-intermediates",
    catalogNo: 4,
    name: "Mic Drop (I)",
    eventKind: "Solo Singing",
    ageTier: "intermediates",
    ageGroup: "under15",
    ageGroupLabel: L_I,
    participationType: "Onstage",
    teamSize: "1",
    pageNo: "1",
    imageUrl: "/icon/intermediate/mic_drop.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_MIC_DROP,
    rules: rulesBody(RS_MIC_DROP),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "foot-loose-intermediates",
    catalogNo: 5,
    name: "Foot Loose (I)",
    eventKind: "Solo Dance",
    ageTier: "intermediates",
    ageGroup: "under15",
    ageGroupLabel: L_I,
    participationType: "Onstage",
    teamSize: "1",
    pageNo: "1",
    imageUrl: "/icon/intermediate/foot_loose.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_FOOT_LOOSE,
    rules: rulesBody(RS_FOOT_LOOSE),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "wanna-b-picasso-intermediates",
    catalogNo: 11,
    name: "Wanna-B-Picasso (I)",
    sheetHeaderName: "Wanna-B-Picasso (I)",
    eventKind: "Inspired Drawing",
    ageTier: "intermediates",
    ageGroup: "under15",
    ageGroupLabel: L_I,
    participationType: "Offstage",
    teamSize: "1",
    pageNo: "1",
    imageUrl: "/icon/intermediate/wanna_be_picasso.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_WANNA_B_PICASSO,
    rules: rulesBody(RS_WANNA_B_PICASSO),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "ink-it-intermediates",
    catalogNo: 12,
    name: "Ink It (I)",
    sheetHeaderName: "Ink It (I)",
    eventKind: "Hindi Handwriting",
    ageTier: "intermediates",
    ageGroup: "under15",
    ageGroupLabel: L_I,
    participationType: "Offstage",
    teamSize: "1",
    pageNo: "1",
    imageUrl: "/icon/intermediate/ink_it.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_INK_IT,
    rules: rulesBody(RS_INK_IT),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "tale-spin-intermediates",
    catalogNo: 6,
    name: "Tale Spin",
    eventKind: "Story Telling",
    ageTier: "intermediates",
    ageGroup: "under15",
    ageGroupLabel: L_I,
    participationType: "Onstage",
    teamSize: "1",
    pageNo: "1",
    imageUrl: "/icon/intermediate/tale_spin.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_TALE_SPIN,
    rules: rulesBody(RS_TALE_SPIN),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "knives-out-intermediates",
    catalogNo: 7,
    name: "Knives out (I)",
    eventKind: "Master chef",
    ageTier: "intermediates",
    ageGroup: "under15",
    ageGroupLabel: L_I,
    participationType: "Offstage",
    teamSize: "1",
    pageNo: "1",
    imageUrl: "/icon/intermediate/knives_out.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_KNIVES_OUT,
    rules: rulesBody(RS_KNIVES_OUT),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "brain-burn-intermediates",
    catalogNo: 9,
    name: "Brain Burn",
    eventKind: "GK Crossword",
    ageTier: "intermediates",
    ageGroup: "under15",
    ageGroupLabel: L_I,
    participationType: "Offstage",
    teamSize: "1",
    pageNo: "1",
    imageUrl: "/icon/intermediate/brain_burn.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_BRAIN_BURN,
    rules: rulesBody(RS_BRAIN_BURN),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "nitro-rush-intermediates",
    catalogNo: 10,
    name: "Nitro Rush",
    eventKind: "RC Car Racing",
    ageTier: "intermediates",
    ageGroup: "under15",
    ageGroupLabel: L_I,
    participationType: "Arena",
    teamSize: "1",
    pageNo: "1",
    imageUrl: "/icon/intermediate/nitro_rush.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_NITRO_RUSH,
    rules: rulesBody(RS_NITRO_RUSH),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "mic-drop-seniors",
    catalogNo: 12,
    name: "Mic Drop (S)",
    eventKind: "Solo Singing",
    ageTier: "seniors",
    ageGroup: "over15",
    ageGroupLabel: L_S,
    participationType: "Onstage",
    teamSize: "1",
    pageNo: "1",
    imageUrl: "/icon/seniors/mic_drop.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_MIC_DROP,
    rules: rulesBody(RS_MIC_DROP),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "funk-fusion-seniors",
    catalogNo: 13,
    name: "Funk Fusion",
    eventKind: "Duo Dance",
    ageTier: "seniors",
    ageGroup: "over15",
    ageGroupLabel: L_S,
    participationType: "Onstage",
    teamSize: "2",
    pageNo: "1",
    imageUrl: "/icon/seniors/funk_fusion.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_FUNK_FUSION,
    rules: rulesBody(RS_FUNK_FUSION),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "mind-maze-seniors",
    catalogNo: 15,
    name: "Mind Maze",
    eventKind: "Business Case Study",
    ageTier: "seniors",
    ageGroup: "over15",
    ageGroupLabel: L_S,
    participationType: "Offstage",
    teamSize: "1–2",
    pageNo: "1",
    imageUrl: "/icon/seniors/mind_maze.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_MIND_MAZE,
    rules: rulesBody(RS_MIND_MAZE),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "knives-out-seniors",
    catalogNo: 18,
    name: "Knives out (S)",
    eventKind: "Masterchef",
    ageTier: "seniors",
    ageGroup: "over15",
    ageGroupLabel: L_S,
    participationType: "Offstage",
    teamSize: "2",
    pageNo: "1",
    imageUrl: "/icon/seniors/knives_out.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_KNIVES_OUT,
    rules: rulesBody(RS_KNIVES_OUT),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "tote-studio-seniors",
    catalogNo: 17,
    name: "Tote Studio",
    eventKind: "Tote Bag Designing",
    ageTier: "seniors",
    ageGroup: "over15",
    ageGroupLabel: L_S,
    participationType: "Offstage",
    teamSize: "1",
    pageNo: "1",
    imageUrl: "/icon/seniors/tote_studio.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_TOTE_STUDIO,
    rules: rulesBody(RS_TOTE_STUDIO),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "sher-lock-key-seniors",
    catalogNo: 16,
    name: "Sher-Lock&Key",
    eventKind: "Mystery Solving",
    ageTier: "seniors",
    ageGroup: "over15",
    ageGroupLabel: L_S,
    participationType: "Arena",
    teamSize: "2–3",
    pageNo: "1",
    imageUrl: "/icon/seniors/sherlock_n_key.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_SHER_LOCK_KEY,
    rules: rulesBody(RS_SHER_LOCK_KEY),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "profit-or-laugh-seniors",
    catalogNo: 19,
    name: "Profit or Laugh",
    eventKind: "Pitch with a twist",
    ageTier: "seniors",
    ageGroup: "over15",
    ageGroupLabel: L_S,
    participationType: "Onstage",
    teamSize: "1",
    pageNo: "1",
    imageUrl: "/icon/seniors/profit_and_laugh.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_PROFIT_OR_LAUGH,
    rules: rulesBody(RS_PROFIT_OR_LAUGH),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "ink-it-seniors",
    catalogNo: 20,
    name: "Ink It",
    eventKind: "Hindi Handwriting",
    ageTier: "seniors",
    ageGroup: "over15",
    ageGroupLabel: L_S,
    participationType: "Offstage",
    teamSize: "1",
    pageNo: "1",
    imageUrl: "/icon/seniors/ink_it.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_INK_IT,
    rules: rulesBody(RS_INK_IT),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "viral-voltage-seniors",
    catalogNo: 22,
    name: "Viral Voltage",
    eventKind: "Insta Reel challenge",
    ageTier: "seniors",
    ageGroup: "over15",
    ageGroupLabel: L_S,
    participationType: "Online",
    teamSize: "1",
    pageNo: "1",
    imageUrl: "/icon/seniors/viral_voltage.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_VIRAL_VOLTAGE,
    rules: rulesBody(RS_VIRAL_VOLTAGE),
    registrationUrl: "",
    resultsUrl: "",
  },
  {
    id: "clash-of-clans-family",
    catalogNo: 23,
    name: "Clash of Clans",
    eventKind: "Family Game Show",
    ageTier: "family",
    ageGroup: "over15",
    ageGroupLabel: L_F,
    participationType: "Offstage + Onstage",
    teamSize: "4",
    pageNo: "1",
    imageUrl: "/icon/family/clash_of_clans.png",
    prizes: PRIZES_TBA,
    shortDescription: RS_TRADE_OFF_ARENA,
    rules: rulesBody(RS_TRADE_OFF_ARENA),
    registrationUrl: "",
    resultsUrl: "",
  },
];
